export default {"src":"https://fishbrain.com/_next/static/media/signupBackground.7382ce35.svg","height":288,"width":357,"blurWidth":0,"blurHeight":0};